// excelService.js
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { addDoc, collection } from "firebase/firestore";

// 1. وظيفة التصدير (Export)
export const exportToExcel = (data, fileName) => {
    // تنظيف البيانات من الـ IDs الخاصة بـ Firebase لتبدو نظيفة في الإكسيل
    const cleanData = data.map(({ id, ...rest }) => rest);
    
    const worksheet = XLSX.utils.json_to_sheet(cleanData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
    
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    saveAs(dataBlob, `${fileName}_${new Date().toLocaleDateString('ar-EG')}.xlsx`);
};

// 2. وظيفة الاستيراد (Import)
export const importFromExcel = (file, db, collectionName, onComplete) => {
    const reader = new FileReader();
    reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);

        if (window.confirm(`هل تريد استيراد ${jsonData.length} سجل إلى ${collectionName}؟`)) {
            jsonData.forEach(async (row) => {
                try {
                    await addDoc(collection(db, collectionName), {
                        ...row,
                        createdAt: new Date().toISOString()
                    });
                } catch (err) {
                    console.error("خطأ في سطر:", err);
                }
            });
            if (onComplete) onComplete();
        }
    };
    reader.readAsArrayBuffer(file);
};

// 3. وظيفة الطباعة (Print)
export const handlePrint = () => {
    window.print();
};